module.exports = __webpack_public_path__ + "images/footer-reviews-testimonials-page-mobile.webp";